var map = {
	"./bandeau-navigart-fracGL.png": "../../navigart-conf/img/branding/bandeau-navigart-fracGL.png",
	"./branding.png": "../../navigart-conf/img/branding/branding.png",
	"./fracno_bandeau_nav3.jpg": "../../navigart-conf/img/branding/fracno_bandeau_nav3.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./img/branding sync recursive ^\\.\\/.*$";